
import axios from 'axios'

export default {
    getIcare(){
        return axios.get('/icareyouth')
            .then(response => {
                return response.data
            })
    },
    getIcareDataSource(params){
        return axios.get('/icareyouth/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getIcarebyID(id){
        return axios.get('/icareyouth/' + id)
            .then(response => {
                return response.data
            })
    },  
    getIcareDetails(id){
        return axios.get('/icareyouth/' + id + '/details')
            .then(response => {
                return response.data
            })
    },   
    createIcare(formdata){
        return axios.post('/icareyouth', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcare(id,formdata){
        return axios.put('/icareyouth/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    
    destroyIcare(id){
        return axios.delete('/icareyouth/' + id)
            .then(response => {
                return response.data
            })
    }, 
    assign_leader_Icare(id,formdata){
        return axios.put('/icareyouth/' + id + '/assign-as-leader', formdata)
            .then(response => {
                return response.data
            })
    },  
    
    assign_core_team_Icare(id,formdata){
        return axios.put('/icareyouth/' + id + '/assign-as-core-team', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_core_team_Icare(id,formdata){
        return axios.put('/icareyouth/' + id + '/remove-core-team', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_leader_Icare(id,formdata){
        return axios.put('/icareyouth/' + id + '/remove-leader', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_member_Icare(id,formdata){
        return axios.put('/icareyouth/' + id + '/remove-member', formdata)
            .then(response => {
                return response.data
            })
    }, 

    getIcareNote(id){
        return axios.get('/icareyouth/' + id + '/get-note')
            .then(response => {
                return response.data
            })
    }, 

    createIcareNote(id,formdata){
        return axios.post('/icareyouth/' + id + '/note', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcareNote(id,icareyouth,formdata){
        return axios.put('/icareyouth/' + id + '/note/' + icareyouth , formdata)
            .then(response => {
                return response.data
            })
    },
    deleteIcareNote(id){
        return axios.delete('/note/' + id )
            .then(response => {
                return response.data
            })
    },

    getIcareMeeting(id){
        return axios.get('/icareyouth/' + id + '/get-meeting')
            .then(response => {
                return response.data
            })
    }, 

    createIcareMeeting(id,formdata){
        return axios.post('/icareyouth/' + id + '/meeting', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcareMeeting(id,icareyouth,formdata){
        return axios.put('/icareyouth/' + id + '/meeting/' + icareyouth, formdata)
            .then(response => {
                return response.data
            })
    },

    deleteIcareMeeting(id){
        return axios.delete('/meeting/' + id  )
            .then(response => {
                return response.data
            })
    },
    
   
}